<div class="flex items-center gap-6">
  <div class="avatar-preview shrink-0">
    @if (previewDisplay()) {
      <img [src]="previewDisplay()" alt="Foto de perfil" class="avatar-preview__img" />
    } @else {
      <i class="pi pi-user text-3xl text-slate-300"></i>
    }
  </div>

  <div class="flex flex-col gap-2">
    <input
      #fileInput
      type="file"
      class="hidden"
      accept="image/jpeg,image/png,.jpg,.jpeg,.png"
      (change)="onFileSelected($event)"
    />
    <p-button
      type="button"
      [label]="buttonLabel()"
      icon="pi pi-upload"
      severity="secondary"
      [outlined]="true"
      [disabled]="disabled()"
      (onClick)="openFilePicker()"
    />
    <p class="text-xs text-slate-500 m-0">Solo JPG o PNG. Se recortará en círculo.</p>
  </div>
</div>

<p-dialog
  header="Ajustar foto de perfil"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(420px, 95vw)' }"
  [visible]="cropDialogVisible()"
  (visibleChange)="onDialogVisibleChange($event)"
>
  <div class="flex flex-col gap-4 items-center">
    <p class="text-sm text-slate-600 m-0 text-center">
      Arrastra la imagen para centrarla. El área circular es lo que se verá en tu perfil.
    </p>

    <div
      #viewport
      class="avatar-crop-viewport"
      [class.avatar-crop-viewport--dragging]="dragging()"
      (pointerdown)="onPointerDown($event)"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp($event)"
      (pointercancel)="onPointerUp($event)"
    >
      @if (sourceUrl(); as src) {
        <img
          class="avatar-crop-image"
          [src]="src"
          [ngStyle]="imageStyle()"
          alt="Recorte"
          draggable="false"
          (load)="onImageLoad($event)"
        />
      }
      <div class="avatar-crop-mask" aria-hidden="true"></div>
      <div class="avatar-crop-ring" aria-hidden="true"></div>
    </div>

    <div class="w-full flex items-center gap-3 px-1">
      <i class="pi pi-search-minus text-slate-400 text-sm"></i>
      <input
        class="avatar-zoom-range flex-1"
        type="range"
        min="1"
        max="3"
        step="0.05"
        [value]="zoom()"
        (input)="onZoomChange(($any($event.target)).value)"
      />
      <i class="pi pi-search-plus text-slate-400 text-sm"></i>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        type="button"
        label="Cancelar"
        severity="secondary"
        [text]="true"
        [disabled]="processing()"
        (onClick)="cancelCrop()"
      />
      <p-button
        type="button"
        label="Usar foto"
        icon="pi pi-check"
        [loading]="processing()"
        (onClick)="confirmCrop()"
      />
    </div>
  </ng-template>
</p-dialog>
